import { getMsalAuth, CacheLocation } from '@iamexperiences/feature-auth';
import { settingsManager } from './shared/settings';
import { getTelemetry } from './Telemetry/Telemetry';

const authority = settingsManager.getRequired('authAuthorityEndpoint');

const clientId = settingsManager.getRequired('clientId');

export const auth = getMsalAuth(
  {
    clientId,
    authority,
    cacheLocation: CacheLocation.SessionStorage,
  },
  {
    onError: (message: string) => {
      getTelemetry()?.error('feature-auth/error', message);
    },
    onInfo: (message: string) => {
      getTelemetry()?.reportCustomEvent('feature-auth/info', { message });
    },
  },
);
